var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import '../participant-item/sgdf-participant-item.js';
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js';
import '../../atoms/button/button.js';
import '../../atoms/icon/icon.js';
import '../../atoms/round-checkbox/sgdf-round-checkbox.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { serialize } from '@shoelace-style/shoelace/dist/utilities/form';
import styles from './ParticipantPicker.styles';
import { emit } from '../../internal/event.js';
import { SKELETON_PARTICIPANT } from '../participant.utils.js';
const getFormattedParticipant = (participant) => {
    var _a;
    return ({
        fonction: participant.fonction,
        structure: (_a = participant.structure_principale) === null || _a === void 0 ? void 0 : _a.label,
    });
};
export class SgdfParticipantPicker extends LitElement {
    constructor() {
        super(...arguments);
        this.participantsField = 'participants';
        this.skeleton = false;
        this.getInfo = undefined;
    }
    connectedCallback() {
        super.connectedCallback();
        this.onSubmit = this.onSubmit.bind(this);
        this.updateComplete.then(() => {
            var _a, _b, _c;
            (_b = (_a = this.dialog) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => this.dialog.show());
            (_c = this.saveButton) === null || _c === void 0 ? void 0 : _c.addEventListener('click', () => {
                this.onSubmit();
                this.dialog.hide();
            });
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    isInTeam(participant) {
        if (!this.team) {
            return false;
        }
        return !!participant.teams.find(team => { var _a; return team.id === ((_a = this.team) === null || _a === void 0 ? void 0 : _a.id); });
    }
    render() {
        var _a, _b;
        const membersCount = this.participants.filter(p => this.isInTeam(p)).length;
        const skeleton = this.skeleton || this.participants == null;
        const participants = skeleton
            ? SKELETON_PARTICIPANT
            : this.participants;
        return html `
            <sl-dialog
                label=${(_b = (_a = this.team) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : 'Selectionner les participants'}
                class="dialog-participants"
            >
                <form class="form" @submit=${(e) => e.preventDefault()}>
                    <div class="participant-list">
                        ${participants.map(participant => {
            var _a;
            return html `
                                <sgdf-participant-item
                                    info=${ifDefined((_a = this.getInfo) === null || _a === void 0 ? void 0 : _a.call(this, participant))}
                                    .participant=${participant}
                                    .getFields=${getFormattedParticipant}
                                    .skeleton=${skeleton}
                                >
                                    <sgdf-round-checkbox
                                        id=${participant.id}
                                        name=${this.participantsField}
                                        ?checked=${this.isInTeam(participant)}
                                        value=${participant.id}
                                        slot="right"
                                    ></sgdf-round-checkbox>
                                </sgdf-participant-item>
                            `;
        })}
                    </div>
                </form>
                <div slot="footer" class="footer">
                    <sgdf-button class="submit" primary
                        >Enregistrer</sgdf-button
                    >
                </div>
            </sl-dialog>

            <sgdf-button>
                ${!!this.team
            ? html `<span slot="prefix">${membersCount}</span>
                          Stagiaire(s)`
            : null}
                <sgdf-icon name="users" slot="suffix"></sgdf-icon>
            </sgdf-button>
        `;
    }
    async onSubmit() {
        var _a;
        const detail = serialize(this.form);
        const participants = (Array.isArray(detail[this.participantsField])
            ? detail[this.participantsField]
            : [detail[this.participantsField]]);
        const particpantsUpdate = {
            participants: participants.filter(p => !!p),
            teamId: (_a = this.team) === null || _a === void 0 ? void 0 : _a.id,
        };
        emit(this, 'sgdf-participant-picker:submit', {
            detail: particpantsUpdate,
        });
        this.form.reset();
    }
}
SgdfParticipantPicker.styles = styles;
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfParticipantPicker.prototype, "skeleton", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfParticipantPicker.prototype, "participants", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfParticipantPicker.prototype, "team", void 0);
__decorate([
    property()
], SgdfParticipantPicker.prototype, "getInfo", void 0);
__decorate([
    query('.dialog-participants')
], SgdfParticipantPicker.prototype, "dialog", void 0);
__decorate([
    query('.submit')
], SgdfParticipantPicker.prototype, "saveButton", void 0);
__decorate([
    query('.form')
], SgdfParticipantPicker.prototype, "form", void 0);
//# sourceMappingURL=ParticipantPicker.js.map